//
import { ModuleLayout } from '@/components/reusable_components/next'
import TagList from '@/views/Tag/TagList'
import TagCreate from '@/views/Tag/TagCreate'
import TagShowEdit from '@/views/Tag/TagShowEdit'

//
export default {
    path: 'tags',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'tags_list',
            component: TagList,
        },
        {
            path: 'create',
            name: 'tags_create',
            component: TagCreate,
            meta: {
                title: 'Crear tag'
            },
        },
        {
            path: ':id',
            name: 'tags_show_edit',
            component: TagShowEdit,
            meta: {
                title: 'Detalle de tag'
            },
        },
    ],
    meta: {
        title: 'Tags'
    },
}